// Karla shows on application, but not on the downloadeded image. So we use the default sans-serif as a fallback.
export const KARLA_FONT_FAMILY = 'Karla, sans-serif';
export const LORA_FONT_FAMILY = 'Lora, serif';
